import { isAfter } from 'date-fns';
import { validateMaxDate, validateMinDate } from '../DateTimePicker/utils';
import type { DateRange } from './dateRange';

/**
 * Validates the date range against the min and max values. If the min or max value is not provided, the date range is not validated. Null values are allowed.
 * @param dateRange - The date range to validate
 * @param minValue - The min value to validate against
 * @param maxValue - The max value to validate against
 * @param validateTime - Whether to validate the time part or set it to the next day at 10:00 (UTC)
 * @returns The validated date range. Null values are allowed.
 */
export const validateDateRange = (
  dateRange: DateRange,
  minValue: Date | undefined,
  maxValue: Date | undefined,
  validateTime: boolean
) => {
  const { from, to } = dateRange;
  // If the from date is after the to date, return null
  if (from && to && isAfter(from, to)) {
    return { from: null, to: null };
  }
  const validatedFrom = from && minValue ? validateMinDate(from, minValue, validateTime) : from;
  const validatedTo = to && maxValue ? validateMaxDate(to, maxValue, validateTime) : to;
  return { from: validatedFrom, to: validatedTo };
};
